// extracted by mini-css-extract-plugin
export default {"register":"ma0s11DOKy886M0nOA4MrA=="};